import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { GAEvent } from '~/utils';
import { GA } from '~/constants';
import { useUserStore } from '~/store';
import { CharacterCardClickEvent } from '../CharacterCard/CharacterCard';
import GameCardInfo from './GameCardInfo/GameCardInfo';

interface CharacterCardProps {
  game_id: string;
  create_username: string;
  liked_count: number;
  thumbnail_file_path: string;
  title: string;
  handleCardClick:
    | (() => void)
    | (({ id, name, desc, type }: CharacterCardClickEvent) => void);
  handlePlayGameClick?: (() => void) | null;
}

export default function GameCard({
  game_id,
  create_username,
  liked_count,
  thumbnail_file_path,
  title,
  handleCardClick,
  handlePlayGameClick = null,
}: CharacterCardProps) {
  const email = useUserStore((state) => state.email);

  const handlePlayClick = handlePlayGameClick
    ? () => {
        // send GA event : CLICK_PLAY_GAME
        GAEvent(email, GA.ACTION.CLICK_PLAY_GAME, {
          game_id,
          game_title: title,
        });
        handlePlayGameClick();
      }
    : null;

  const handleCardThumbnailClick = () => {
    const isMissionGame = !!handlePlayGameClick;

    // send GA event : CLICK_JOIN_GAME
    GAEvent(email, GA.ACTION.CLICK_JOIN_GAME, {
      game_id,
      game_title: title,
    });

    // 미션게임 일 경우 로딩 레이아웃에 카드 배경화면 넘겨줄 필요 없음
    isMissionGame
      ? (handleCardClick as () => void)()
      : handleCardClick({
          id: String(game_id),
          type: 'mystery',
          image: thumbnail_file_path,
        });
  };

  return (
    <>
      <Container onClick={handleCardThumbnailClick}>
        <GameCardBackgroundImage
          src={`${thumbnail_file_path}`}
          alt='game card'
          style={{ width: '100%', height: '100%', pointerEvents: 'none' }}
        />
        <GameCardInfo
          title={title}
          create_username={create_username}
          liked_count={liked_count}
          handlePlayGameClick={handlePlayClick}
        />
      </Container>
    </>
  );
}

const Container = styled.div`
  ${({ theme }) => css`
    position: relative;
    width: 214px;
    height: 257px;
    overflow: hidden;
    border: 1px solid ${theme.stroke.stroke_1};
    border-radius: 18px;
    background: ${theme.backgroundColor.bg_dark_2};
  `}
`;

const GameCardBackgroundImage = styled.img`
  width: 100%;
  height: 100%;
  pointer-events: 'none';
  object-fit: cover;
`;
